import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

import { Button, UncontrolledTooltip } from "reactstrap";
import { Trash2 } from "react-feather";
import PopupDelete from "../deletePopUp";
import { updateComponent, createComponent } from "../../../services/labServices";
import { ComponentType, Container, InputDescription, InputTitle } from "./styles";
import { handleErrors } from "../../../services/handleErrors";

export const createOrUpdateComponent = async (data, id) => {
  if (id) {
    try {
      const { message, result } = await updateComponent(id, data);
      return { message, result };
    } catch (error) {
      handleErrors(error, toast.error);
    }
  }
  try {
    const { message, result } = await createComponent(data);
    return { message, result };
  } catch (error) {
    handleErrors(error, toast.error);
  }
  return true;
};
export default function FormVideoComponent({ unitId, componentInfo, componentList, handleDelete, setComponentForm, setReloadData, readOnly }) {
  const [deleteComponentPopUp, setDeleteComponentPopUp] = useState(false);

  const componentQuiz = componentList && componentList.find((component) => component.type === "Quiz");
  const order = componentQuiz ? componentQuiz.sort_order - 1 : (componentList && componentList.length + 1) || 1;

  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      content_url: "",
      type: "Video",
      sort_order: "",
    },

    onSubmit: async (values) => {
      const dataToCreateVideoComponent = {
        title: values.title,
        description: values.description,
        content_url: values.content_url,
        unit_id: unitId,
        type: values.type,
        sort_order: order,
      };

      const { message } = await createOrUpdateComponent(dataToCreateVideoComponent, componentInfo && componentInfo.id);
      if (message) {
        setReloadData(true);
        setComponentForm(false);
        toast.success("Guardado con exito");
      }
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().required("Este campo es requerido."),
      description: Yup.string().required("Este campo es requerido."),
      content_url: Yup.string().required("Este campo es requerido."),
    }),
  });

  useEffect(() => {
    if (componentInfo) {
      formik.setFieldValue("title", componentInfo.title);
      formik.setFieldValue("description", componentInfo.description);
      formik.setFieldValue("content_url", componentInfo.content_url);
    }
  }, [componentInfo]);

  return (
    <>
      {deleteComponentPopUp && (
        <PopupDelete
          isOpen={deleteComponentPopUp}
          toggle={() => setDeleteComponentPopUp(!deleteComponentPopUp)}
          elementToDelete={componentInfo}
          type="component"
          handleDelete={handleDelete}
        />
      )}
      <Container>
        <form onSubmit={formik.handleSubmit}>
          <div>
            <div className="d-flex justify-content-between align-items-start">
              <div className="w-100 ">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <ComponentType>{componentInfo ? `${componentInfo.sort_order}.` : ""} Componente Video</ComponentType>
                  <UncontrolledTooltip target="btnDelete">Eliminar componente</UncontrolledTooltip>
                  <Button size="xs" id="btnDelete" color="link" onClick={() => setDeleteComponentPopUp(true)} disabled={!componentInfo || readOnly}>
                    <Trash2 size="20" color="black" />
                  </Button>
                </div>
                <div className="mb-3">
                  <InputTitle
                    type="text"
                    id="title"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.title}
                    maxLength={40}
                    placeholder={formik.errors.title && formik.touched.title ? formik.errors.title : "Título"}
                    style={formik.errors.title && formik.touched.title ? { borderBottom: "1px solid red" } : null}
                  />
                </div>
                <div className="mb-3">
                  <InputDescription
                    type="text"
                    id="description"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description}
                    maxLength="100"
                    placeholder={formik.errors.description && formik.touched.description ? formik.errors.description : "Descripción"}
                    style={formik.errors.description && formik.touched.description ? { borderBottom: "1px solid red" } : null}
                  />
                </div>
                <div className="mb-3">
                  <InputTitle
                    type="URL"
                    id="content_url"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.content_url}
                    placeholder={formik.errors.content_url && formik.touched.content_url ? formik.errors.content_url : "video URL"}
                    style={formik.errors.content_url && formik.touched.content_url ? { borderBottom: "1px solid red" } : null}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Button
                className="mr-2"
                size="sm"
                color="btn"
                type="button"
                onClick={() => {
                  setComponentForm(null);
                  formik.resetForm();
                }}
              >
                Cancelar
              </Button>
              <Button size="sm" className="btn btn-success" type="submit" disabled={formik.isSubmitting || readOnly}>
                Guardar
              </Button>
            </div>
          </div>
        </form>
      </Container>
    </>
  );
}
